window.customElements.define("in-your-homes",
  class InYourHomes extends window.HTMLElement {
    connectedCallback() {
      this.prev = this.querySelector("#prev");
      this.next = this.querySelector("#next");
      this.initSlider();
    }

    initSlider() {
      const slider = new KeenSlider(this.querySelector(".keen-slider"), {
        slides: {
          perView: 1.25,
          spacing: 12,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 4.25,
              spacing: 12,
            }
          }
        },
        loop: false, // Ensure the slider does not loop
        rubberband: false, // Prevent over-scrolling
        centered: false, // Ensure the slides are not centered
        edgePadding: 12 // Add edge padding
      });

      this.prev.addEventListener("click", () => {
        slider.prev();
      });

      this.next.addEventListener("click", () => {
        slider.next();
      });

    }
  }
);
